var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Day',{attrs:{"day":"12.12.2017"}},[_c('div',{attrs:{"slot":"page-content"},slot:"page-content"},[_c('h2',[_vm._v("Wir haben ganz schön viel Urlaub zu kalten Jahreszeiten gemacht!")]),_c('p',{staticClass:"center"},[_vm._v(" Da muss man seine kalten Händchen aber gut einpacken und ... ")]),_c('Gallery',{attrs:{"directory":"2017/12"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }